import React from 'react'
import style from './style.module.less'

export default ({
  style: styleProp = {},
  contentStyle = {},
  title,
  extra,
  children
}) => {
  return (
    <div className={style.block} style={styleProp}>
      <div className={style.header}>
        <div className={style.title}>{title}</div>
        {extra && <div className={style.extra}>{extra}</div>}
      </div>

      <div className={style.content} style={contentStyle}>
        {children}
      </div>
    </div>
  )
}
